export type GetOauthOpenidConfigurationRequest = {
  authority: string;
};
export type GetOauthOpenidConfigurationResponse = {
  issuer: string;
  authorization_endpoint: string;
  token_endpoint: string;
  introspection_endpoint: string;
  end_session_endpoint: string;
  userinfo_endpoint: string;
  device_authorization_endpoint: string;
  jwks_uri: string;
  grant_types_supported: string[];
  response_types_supported: string[];
  response_modes_supported: string[];
  scopes_supported: string[];
  claims_supported: string[];
  id_token_signing_alg_values_supported: string[];
  code_challenge_methods_supported: string[];
  subject_types_supported: string[];
  token_endpoint_auth_methods_supported: string[];
  introspection_endpoint_auth_methods_supported: string[];
  claims_parameter_supported: boolean;
  request_parameter_supported: boolean;
  request_uri_parameter_supported: boolean;
};
export const GetOauthOpenidConfiguration = async (
  request: GetOauthOpenidConfigurationRequest
): Promise<GetOauthOpenidConfigurationResponse> => {
  const url = `${request.authority}/.well-known/openid-configuration`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(response.statusText);
  }
  const config: GetOauthOpenidConfigurationResponse = await response.json();
  return config;
};

export type PostOauthClientCredentialsAuthorizationRequest = {
  token_endpoint: string;
  client_id: string;
  client_secret: string;
  scope?: string;
};
export type PostOauthClientCredentialsAuthorizationResponse = {
  access_token: string;
  token_type: string;
  expires_in: string;
  scope?: string;
};
export const PostOauthClientCredentialsAuthorization = async (
  request: PostOauthClientCredentialsAuthorizationRequest
): Promise<PostOauthClientCredentialsAuthorizationResponse> => {
  const body =
    `grant_type=client_credentials&client_id=${request.client_id}&client_secret=${request.client_secret}` +
    (request.scope ? `&scope=${request.scope}` : "");
  const response = await fetch(request.token_endpoint, {
    method: "POST",
    body,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
  if (!response.ok) {
    throw new Error(response.statusText);
  }
  const clientCredentials =
    (await response.json()) as PostOauthClientCredentialsAuthorizationResponse;
  return clientCredentials;
};

export type PostOauthBasicAuthorizationRequest = {
  token_endpoint: string;
  client_id: string;
  client_secret: string;
  scope?: string;
};
export type PostOauthBasicAuthorizationResponse = {
  access_token: string;
  token_type: string;
  expires_in: string;
  scope?: string;
};
export const PostOauthBasicAuthorization = async (
  request: PostOauthBasicAuthorizationRequest
): Promise<PostOauthBasicAuthorizationResponse> => {
  const token = btoa(`${request.client_id}:${request.client_secret}`);
  const body =
    `grant_type=client_credentials` +
    (request.scope ? `&scope=${request.scope}` : "");
  const response = await fetch(request.token_endpoint, {
    method: "POST",
    body,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Basic ${token}`,
    },
  });
  if (!response.ok) {
    throw new Error(response.statusText);
  }
  const basic = (await response.json()) as PostOauthBasicAuthorizationResponse;
  return basic;
};
